import React, { useEffect } from "react";
import * as styles from "./Awards.module.scss";
import { awardsList } from "../../../../hooks/useAwardsList";
import classNames from "classnames";
import Glide from "@glidejs/glide";
import { useIntl } from "gatsby-plugin-intl";

const Awards: React.FC = () => {
	useEffect(() => {
		let glide: Glide | null = null;

		const initGlide = () => {
			const awardsEl = document.querySelector(`.${styles.awards}`);
			if (!awardsEl) return;

			if (window.innerWidth <= 598 && !glide) {
				glide = new Glide(awardsEl, {
					type: "carousel",
					keyboard: false,
					autoplay: false,
					hoverpause: false,
					peek: { before: 0, after: 100 },
					startAt: 0,
					perView: 3,
					gap: 16,
					breakpoints: {
						500: {
							perView: 1,
							peek: { before: 0, after: 135 },
						},
					},
				});
				glide.mount();
			} else if (window.innerWidth >= 598 && glide) {
				glide.destroy();
				glide = null;
			}
		};

		initGlide(); // инициализация при загрузке
		window.addEventListener("resize", initGlide);

		return () => {
			window.removeEventListener("resize", initGlide);
			if (glide) glide.destroy();
		};
	}, []);

	const avardsListClasses = classNames(styles.awardsList, "glide__slides");
	const intl = useIntl()
	return (
		<section className={styles.awards}>
			<h2>{intl.formatMessage({ id: "index.awards.title" })}</h2>
			<p>{intl.formatMessage({ id: "index.awards.text" })}</p>
			<div className="glide__track" data-glide-el="track">
				<ul className={avardsListClasses}>
					{awardsList.map((award, index) => (
						<li key={index} className={styles.awardsListItem}>
							<img
								src={award.link}
								width={award.width}
								height={award.height}
								alt={award.alt}
							/>
						</li>
					))}
				</ul>
			</div>
		</section>
	);
};

export default Awards;
